// import { createContext, Dispatch, SetStateAction } from 'react';
//
// import { DbFileVersion } from '~src/types/db';
//
// export interface FileVersionsCtx {
//   fileVersionsContext: {
//     [versionedFileId: number]: DbFileVersion | undefined;
//   };
//   setFileVersionsContext: Dispatch<
//     SetStateAction<FileVersionsCtx['fileVersionsContext']>
//   >;
// }
//
// /**
//  * Holds slected file versions for info & download
//  */
// const FileVersionsContext = createContext({
//   fileVersionsContext: {},
//   setFileVersionsContext: () => ({}),
// } as FileVersionsCtx);
//
// export default FileVersionsContext;

import { createContext, Dispatch, SetStateAction } from 'react';
import { DbFileVersion } from '~src/types/db';

// Extend the DbFileVersion with an optional manual flag.
// This makes it backward compatible with files that reference properties such as updated_at.
export interface FileVersionSelection extends DbFileVersion {
  manual?: boolean;
}

export interface FileVersionsCtx {
  fileVersionsContext: {
    [versionedFileId: number]: FileVersionSelection | undefined;
  };
  setFileVersionsContext: Dispatch<
    SetStateAction<FileVersionsCtx['fileVersionsContext']>
  >;
}

/**
 * Holds selected file versions for info & download.
 */
const FileVersionsContext = createContext<FileVersionsCtx>({
  fileVersionsContext: {},
  setFileVersionsContext: () => ({}),
});

export default FileVersionsContext;
